import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css';

function formatTemplate(item) { // eslint-disable-line class-methods-use-this
  if (!item.id) {
    return item.text;
  }

  const option = item.element;
  const avatar = option.dataset.avatarSrc;
  if (!avatar) {
    return item.text;
  }

  const content = document.createElement('div');
  content.innerHTML = `<span class="avatar avatar-xs mr-3"><img class="avatar-img rounded-circle" src="${avatar}" alt="${item.text}"></span><span>${item.text}</span>`;

  return content;
}

export default function (el) { // eslint-disable-line class-methods-use-this
  let elementOptions = el.dataset.options;
  elementOptions = elementOptions ? JSON.parse(elementOptions) : {};
  const defaultOptions = {
    dropdownParent: $(el).closest('.modal').length ? $(el).closest('.modal') : $(document.body),
    templateResult: formatTemplate,
  };
  const options = Object.assign(elementOptions, defaultOptions);

  $(el).select2(options);
}
